import React from 'react';
import Banner from './Banner';
import RequestForm from './RequestForm';
import GenerateReports from './GenerateReports';

function Home() {
    return (
        <>
            <Banner />
            <GenerateReports />
            <RequestForm />
        </>
    );
}

export default Home;
